<template>
  <div class="room-status-container">
    <div class="room-status-content">
      <!-- 楼层导航 -->
      <div class="floor-navigation">
        <!-- <h6 class="navigation-title">楼层导航</h6> -->
        <div class="navigation-buttons">
          <button v-for="floor in floors" :key="floor" :class="{ active: currentFloor === floor }"
            @click="scrollToFloor(floor)" class="floor-button">
            {{ floor }}
          </button>
        </div>
      </div>

      <!-- 房间列表 -->
      <div class="room-list">
        <!-- 当没有房间数据时显示提示 -->
        <div v-if="roomList.length === 0" class="empty-tip">
          <el-empty description="暂无房间数据"></el-empty>
        </div>

        <!-- 按楼层分组展示 - 只显示当前选中的楼层 -->
        <div v-if="floors.length > 0" class="floor-section">

          <div class="floor-rooms">
            <transition name="fade" mode="out-in">
              <div :key="currentDisplayFloor" class="room-list-container">
                <div v-for="room in roomsByFloor[currentDisplayFloor]" :key="room.room_num" class="room-item"
                  :class="roomStatusClassMap[room.status] || ''">
                  <div class="room-header">
                    <span class="room-num">{{ room.room_num }}</span>
                    <div class="tenant-info" v-if="room.tenant.length > 0 && room.status === 1">
                      <img v-for="item in room.tenant" :src="item.sex === '男' ? man : woman" class="tenant-item" />
                    </div>
                    <div class="bill-status">
                      <img :src="room.bill === '待' ? dai : ''" alt="账单状态" class="bill-icon"
                        v-show="room.bill === '待'" />
                      <img :src="room.bill === '欠' ? qian : ''" alt="账单状态" class="bill-icon"
                        v-show="room.bill === '欠'" />
                    </div>
                  </div>
                  <div class="room-info">
                    <div class="room-status">
                      <span class="status-text">{{ roomStatusTextMap[room.status] }}</span>
                      <span class="day-count" :class="{
                        'days-warning': room.status === 1 && room.day <= 30,
                        'days-normal': room.status === 1 && room.day > 30,
                        'days-vacant': room.status === 2
                      }">{{ room.day }}</span><span class="status-text">天</span>
                    </div>
                    <div class="device-icons">
                      <img :src="room.water === '开' ? waterTrue : waterFalse" alt="水表状态" class="device-icon"
                        :class="{ 'device-on': room.water === '开' }" />
                      <img :src="room.electr === '开' ? electrTrue : electrFalse" alt="电表状态" class="device-icon"
                        :class="{ 'device-on': room.electr === '开' }" />
                      <img :src="room.lock === '正常' ? lockTrue : lockFalse" alt="门锁状态" class="device-icon lock-icon"
                        :class="{ 'lock-normal': room.lock === '正常', 'lock-warning': room.lock === '失联' }" />
                      <span class="lock-battery" :class="{ 'battery-low': room.lock_electr <= 15 }">{{ room.lock_electr
                        }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { get_room_status } from '@/api/api.js'
export default {
  name: 'RoomStatus',
  data () {
    return {
      roomList: [],
      roomsByFloor: {},
      floors: [],
      currentFloor: '',
      currentDisplayFloor: '1F',
      // 设备状态图标
      waterTrue: require('@/assets/waterTrue.png'),
      waterFalse: require('@/assets/waterFalse.png'),
      electrTrue: require('@/assets/electrTrue.png'),
      electrFalse: require('@/assets/electrFalse.png'),
      lockTrue: require('@/assets/lockTrue.png'),
      lockFalse: require('@/assets/lockFalse.png'),
      man: require('@/assets/man.png'),
      woman: require('@/assets/woman.png'),
      dai: require('@/assets/dai.png'),
      qian: require('@/assets/qian.png'),
      // 状态映射
      roomStatusClassMap: {
        1: 'room-occupied',
        2: 'room-vacant',
        3: 'room-unpublished'
      },
      roomStatusTextMap: {
        1: '租期剩余',
        2: '空置',
        3: '空置'
      }
    }
  },
  mounted () {
    this.getRoomStatus()
    // this.useMockData()
  },

  methods: {
    scrollToFloor (floor) {
      this.currentFloor = floor
      this.currentDisplayFloor = floor
    },
    getFloor (roomNum) {
      const roomNumStr = String(roomNum)
      const firstChar = roomNumStr[0]
      if (/\d/.test(firstChar)) {
        return firstChar + 'F'
      } else {
        return '其他楼层'
      }
    },
    groupRoomsByFloor (rooms) {
      const grouped = {}
      rooms.forEach(room => {
        const floor = this.getFloor(room.room_num)
        if (!grouped[floor]) {
          grouped[floor] = []
        }
        grouped[floor].push(room)
      })
      this.roomsByFloor = grouped
      this.floors = Object.keys(grouped).sort((a, b) => {
        const aIsFloor = /\d+楼/.test(a)
        const bIsFloor = /\d+楼/.test(b)
        
        if (aIsFloor && bIsFloor) {
          return parseInt(a) - parseInt(b)
        } else if (aIsFloor) {
          return -1
        } else if (bIsFloor) {
          return 1
        } else {
          return a.localeCompare(b)
        }
      })

      if (this.floors.length > 0) {
        this.currentFloor = this.floors.includes('1楼') ? '1楼' : this.floors[0]
        this.currentDisplayFloor = this.currentFloor
      }
      
    },

    async getRoomStatus () {
      const res = await get_room_status()
      if (res.status === 200) {
        this.roomList = res.data
        this.groupRoomsByFloor(res.data)
      }
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.room-status-container {
  padding: 1.25rem;
  background-color: #f5f7fa;
  min-height: calc(100vh - 10rem);
}

.room-status-container h2 {
  margin: 0 0 1.25rem 0;
  color: #303133;
  font-size: 1.25rem;
  font-weight: 600;
}

.room-status-content {
  background-color: #fff;
  padding: 0;
  border: 2px solid #e0e0e0;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 10rem);
  display: flex;
  gap: 0;
}

/* 快捷导航目录样式 */
.floor-navigation {
  /* min-width: 120px; */
  max-width: 140px;
  height: fit-content;
  padding: 1.25rem;
  padding-right: 0;
  /* border-right: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0; */
  /* background: #f9f9f9; */
  margin-right: 0;
  margin-bottom: 0;
}

.navigation-title {
  margin: 0 0 0.8rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #303133;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #ebeef5;
}

.navigation-buttons {
  display: flex;
  flex-direction: column;
  /* gap: 0.3rem; */
}

.floor-button {
  border: none;
  background: none;
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 400;
  color: #606266;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 3rem;
}

.floor-button:hover {
  background: #ecf5ff;
  border-color: #c6e2ff;
  color: #1890ff;
}

.floor-button.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
  border: 1px solid #e0e0e0;
  border-right: none;
}

.room-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.navigation-buttons .el-button {
  transition: all 0.2s ease;
  border-radius: 0.4rem;
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 400;
  border: 1px solid #ebeef5;
  background: #f9f9f9;
  color: #606266;
  text-align: left;
}

.navigation-buttons .el-button:hover {
  background: #ecf5ff;
  border-color: #c6e2ff;
  color: #1890ff;
}

.navigation-buttons .el-button.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
}

.navigation-buttons .el-button.active:hover {
  background: #40a9ff;
  border-color: #40a9ff;
}

/* 房间列表样式 */
.room-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1.25rem;
  padding-left: 0;
  flex: 1;
}

/* 楼层区域样式 */
.floor-section {
  background-color: #fff;
  border-radius: 0rem 0.5rem 0.5rem 0.5rem;
  padding: 1rem;
  /* box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05); */
  border: 1px solid rgba(0, 0, 0, 0.05);
  height: 100%;
}

/* 楼层标题样式 */
.floor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 0.125rem solid #e4e7ed;
}

.floor-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #303133;
}

.floor-room-count {
  font-size: 0.9rem;
  color: #909399;
  background-color: #ecf5ff;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  border: 1px solid #d9ecff;
}

/* 楼层房间列表样式 */
.floor-rooms {
  position: relative;
  min-height: 18.75rem;
}

.room-list-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
  gap: 0.8rem;
  width: 100%;
}

/* 房间列表过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.room-item {
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 0.4rem;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  width: 100%;
  max-width: 7.9rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  /* box-shadow:
    0 0.5rem 1rem rgba(0, 0, 0, 0.08),
    inset 0 0.0625rem 0 rgba(255, 255, 255, 0.6),
    inset 0 -0.0625rem 0 rgba(0, 0, 0, 0.04); */
  transform-style: preserve-3d;
  perspective: 62.5rem;
  transform: translateZ(0);
  animation-fill-mode: both;
}

.room-item:hover {
  box-shadow:
    0 0.75rem 1.5rem rgba(0, 0, 0, 0.12),
    inset 0 0.0625rem 0 rgba(255, 255, 255, 0.8),
    inset 0 -0.0625rem 0 rgba(0, 0, 0, 0.06);
  transform: translateY(-0.125rem) rotateX(5deg) translateZ(1.25rem);
  background: rgba(255, 255, 255, 0.9);
}

.room-num {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
}

/* 房间状态背景色 */
.room-occupied {
  background-color: #C8E5B3 !important;
}

.room-vacant {
  background-color: #FADBDF !important;
}

.room-unpublished {
  background-color: #D9D9D9 !important;
}

/* 房间头部样式 */
.room-header {
  display: flex;
  align-items: center;
  /* margin-bottom: 0.4rem; */
  margin-top: -0.2rem;
}

.room-header>* {
  flex: 1;
}

.room-num {
  text-align: left;
}

.bill-status {
  text-align: right;
  min-height: 1.6rem;
}

/* 租客信息样式 */
.tenant-info {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
}

.tenant-item {
  width: 1.18rem;
  margin: 0 0.1rem;
  flex-shrink: 0;
}

.no-tenant {
  font-size: 1.4rem;
  color: #909399;
}

.bill-icon {
  width: 1.4rem;
  height: auto;
}

/* 房间信息样式 */
.room-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: -0.1rem;
}

.room-status {
  display: flex;
  align-items: center;
}

.status-text {
  font-size: 0.87rem;
  font-weight: bold;
  color: #000;
}

.day-count {
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0 0.1rem;
}

.days-warning {
  color: red;
}

.days-normal {
  color: green;
}

.days-vacant {
  color: #844C57;
}

/* 设备状态样式 */
.device-icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -0.4rem;
}

.device-icon {
  width: 1.3rem;
  height: auto;
}

.device-icon.device-on {
  margin-top: 0.25rem;
  width: 1.15rem;
}

.lock-icon {
  height: 2rem;
  margin-top: 0;
}

.lock-icon.lock-normal {
  width: 1rem;
  margin-top: -0.5rem;
}

.lock-icon.lock-warning {
  height: 1.8rem;
  margin-top: -0.25rem;
}

.lock-battery {
  margin-top: 0.34rem;
  font-size: 0.84rem;
  font-weight: 500;
  color: green;
}

.lock-battery.battery-low {
  color: red;
}

/* 空状态样式 */
.empty-tip {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.5rem 0;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .room-list-container {
    grid-template-columns: repeat(auto-fill, minmax(7rem, 1fr));
    gap: 0.6rem;
  }

  .room-item {
    max-width: 7rem;
    padding: 0.3rem;
  }

  .room-num {
    font-size: 1.1rem;
  }

  .tenant-item {
    width: 1rem;
  }

  .no-tenant {
    font-size: 1.2rem;
  }

  .bill-icon {
    width: 1.2rem;
  }

  .device-icon {
    width: 1.1rem;
  }

  .device-icon.device-on {
    width: 1rem;
  }

  .lock-icon {
    height: 1.8rem;
  }

  .lock-battery {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .room-list-container {
    grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
    gap: 0.5rem;
  }

  .room-item {
    max-width: 6rem;
    padding: 0.25rem;
  }

  .room-num {
    font-size: 1rem;
  }

  .status-text,
  .day-count {
    font-size: 0.75rem;
  }

  .lock-battery {
    font-size: 0.65rem;
  }
}
</style>